import { render, staticRenderFns } from "./switch-widget.vue?vue&type=template&id=32dc242b&scoped=true&"
import script from "./switch-widget.vue?vue&type=script&lang=js&"
export * from "./switch-widget.vue?vue&type=script&lang=js&"
import style0 from "./switch-widget.vue?vue&type=style&index=0&id=32dc242b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc242b",
  null
  
)

export default component.exports